var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResource(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Illustration",
    width: 237,
    height: 250,
    viewBox: "0 0 237 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Controls-icon-Document-Edit",
    transform: "translate(37 14)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2342",
    "data-name": "Rectangle 2342",
    width: 200,
    height: 200,
    fill: "#0098db",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2943",
    "data-name": "Group 2943",
    transform: "translate(15.791 5.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2942",
    "data-name": "Group 2942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3832",
    "data-name": "Path 3832",
    d: "M147.277,54.026a6.31,6.31,0,0,0,6.306-6.317V23.125a12.687,12.687,0,0,0-12.662-12.684H63.575a25,25,0,0,0-15.3,5.943L22.729,39.745a22.672,22.672,0,0,0-6.74,15.322V187.231a12.682,12.682,0,0,0,12.652,12.684H140.921a12.687,12.687,0,0,0,12.662-12.684V152.338a6.306,6.306,0,1,0-12.612,0l-.05,34.944L28.6,187.231V60.039H63.656a6.314,6.314,0,0,0,6.306-6.317V23.079l71.009.045V47.709A6.31,6.31,0,0,0,147.277,54.026ZM33.06,47.406,56.78,25.712c.146-.131.388-.258.57-.389V47.406Z",
    transform: "translate(-15.989 -10.441)",
    fill: "#0098db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3833",
    "data-name": "Path 3833",
    d: "M68.135,38.313H28.968a6.317,6.317,0,0,1,0-12.633H68.135a6.317,6.317,0,0,1,0,12.633Z",
    transform: "translate(11.001 51.327)",
    fill: "#0098db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3834",
    "data-name": "Path 3834",
    d: "M48.183,43.966H28.968a6.317,6.317,0,0,1,0-12.633H48.183a6.317,6.317,0,0,1,0,12.633Z",
    transform: "translate(11.001 74.241)",
    fill: "#0098db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    d: "M41.115,49.62H28.968a6.317,6.317,0,0,1,0-12.633H41.115a6.317,6.317,0,0,1,0,12.633Z",
    transform: "translate(11.001 97.158)",
    fill: "#0098db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3836",
    "data-name": "Path 3836",
    d: "M43.48,23.435",
    transform: "translate(95.203 42.228)",
    fill: "#0098db",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3837",
    "data-name": "Path 3837",
    d: "M121.814,32.525l-8.056-8.292a13.841,13.841,0,0,0-19.447,0L41.624,78.489l-.005.005a38.751,38.751,0,0,0-8.566,15.514L30.884,102.9a11.213,11.213,0,0,0,2.447,10.561,10.729,10.729,0,0,0,7.955,3.3,13.34,13.34,0,0,0,2.421-.227l9.484-1.723a33.551,33.551,0,0,0,15.946-8.5l52.672-54.252A14.113,14.113,0,0,0,121.814,32.525ZM50.942,102.381l-7.269,1.309L45.3,97.01a22.605,22.605,0,0,1,2.189-5.175l8.384,8.631A18.369,18.369,0,0,1,50.942,102.381Zm10.876-6.66-9.666-9.955,38.5-39.643,9.661,9.95Zm50.951-52.479-7.179,7.393-9.661-9.95,7.426-7.646a.919.919,0,0,1,1.357,0l8.061,8.3A1.448,1.448,0,0,1,112.769,43.243Z",
    transform: "translate(42.687 29.282)",
    fill: "#0098db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3838",
    "data-name": "Path 3838",
    d: "M33.076,35.632",
    transform: "translate(53.122 91.666)",
    fill: "#0098db",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_469",
    "data-name": "Ellipse 469",
    cx: 41.268,
    cy: 6.65,
    rx: 41.268,
    ry: 6.65,
    transform: "translate(0 236.701)",
    fill: "#6639b7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M467.937,344.243a.225.225,0,0,0-.064-.11c-.631-.624-8.678-12.021-8.678-12.021s-.423-1.273-1.11-2.927a2.911,2.911,0,0,0,.487-.954,3.3,3.3,0,0,0,.08-.445c0-.047.034-.085.047-.132a3.225,3.225,0,0,0-.042-1.748,3.019,3.019,0,0,1-.174.424,7.1,7.1,0,0,0-.635-1.417c-1.067-1.841-2.592-3.393-3.714-5.188a14.053,14.053,0,0,1-1.91-9.315v.5a14.541,14.541,0,0,1,.254-1.909,13.252,13.252,0,0,1,.707-2.1c1.008-2.312,2.638-4.327,3.63-6.647a12.605,12.605,0,0,0,.754-2.431,13.631,13.631,0,0,0,.377-4.263,6.8,6.8,0,0,1-.106,1.014,13.817,13.817,0,0,0-3.892-9.192c-3.46-3.482-8.428-4.836-13.18-5.548a12.063,12.063,0,0,1-5.548-2.121,9.633,9.633,0,0,0-6.319-1.209,10.417,10.417,0,0,0-6.433,3.186c-2.257,2.486-3.236,6.006-5.87,8.1-1.6,1.272-3.621,1.866-5.48,2.732s-3.617,2.121-4.214,3.979v.068l-.026.068c-.618,2.2.576,4.433,1.2,6.626a26.885,26.885,0,0,1,.724,7.012c.047,2.867.089,5.739.042,8.611-.021,1.128-.059,2.269-.144,3.393a17.732,17.732,0,0,0-2.91,1.171,57.651,57.651,0,0,0-4.5,4.458l-6.942,26.562.093.106-.093.361.352-.081a35.752,35.752,0,0,0,7.086,5.964l.3,5.209s.356,5.226,5.154,7.385c.11,1.811.453,9.166-1.135,12.08a13.59,13.59,0,0,0-1.5,6.906s.555,4.42-.076,6.744a11.047,11.047,0,0,0-.08,4.734h0v1.4c0,4.7.055,19.779,0,21.485-.081,2.015,0,31.813,0,31.813s-.394,14.893-1.656,18.927-.945,17.391-.945,17.391-.792,15.911,2.008,19.05c0,.14-.025.284-.03.424v.2c-.034,1.209.2,2.494,1.237,2.889a17.724,17.724,0,0,1,5.447,3.958c.529.7,3.608,2.443,7.623,1.977a57.306,57.306,0,0,1,7.577-.348h0s1.584-.288,1.072-2.261h0a17.668,17.668,0,0,0-2.448-4.365c.161.042.318.076.466.106l.152.03h.119a1.6,1.6,0,0,0,.195,0h.085a1.451,1.451,0,0,0,.237,0h0c1.063-.1,5.027,1.748,5.734,2.969s3.2,2.151,5.082,2.384a36.056,36.056,0,0,0,6.306-.4,23.179,23.179,0,0,0,3.532-.645c.559-.212.678-.891.517-1.654h0a4.307,4.307,0,0,0-1.465-2.477,11.907,11.907,0,0,1-2.262-2.825l-.178-.284c1.182-1.128,3.316-4.819,3.964-5.582.788-.929-1.271-34.9-1.271-34.9V454.108L448.7,437.99l2.207-8.53,1.893-12.878s3.312-15.041,2.291-16.517h0c0-.03-.847-15.516-1.736-19.236-.385-1.659-.288-5.391-.059-9.022a1.784,1.784,0,0,0,.424-1.858,3.869,3.869,0,0,0-.246-.632v-.2a29.13,29.13,0,0,1,5.7-1.943c3.155-.619,2.367-2.248,2.367-2.248s.712-1.4,1.182-2.248.08-8.378,0-9c-.03-.25-.224-1.633-.449-3.2,1.012-.721,2.329-1.616,3.765-2.464C468.776,346.4,468.162,344.688,467.937,344.243ZM426.771,451.784s-2.367,6.049-1.419,7.6-.157,7.3-.157,7.3l-.792,8.53s-2.207,15.822-1.419,19.542c.618,2.918.847,11.635.919,15.27h0a1.058,1.058,0,0,0-.157.076l-.106.055c.364-1.429.212-4.322-1.6-10.142l-.152-24.038s-.279-27.767,1.91-30.872,2.965-8.378,2.965-8.378-.474,7.605-.784,9.62S426.771,451.784,426.771,451.784Zm-4.409,59.749c-.021.051-.047.1-.063.148l-.119-.153A1.246,1.246,0,0,0,422.362,511.533Z",
    transform: "translate(-379.158 -276.422)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M485.047,840.478a41.918,41.918,0,0,1-9.716,1.049c-1.855-.225-4.311-1.168-5.01-2.4s-4.616-3.093-5.667-2.974a3.79,3.79,0,0,1-1.271-.178,15.577,15.577,0,0,1-2.118-.816,3.955,3.955,0,0,1,.047-1.615,2.6,2.6,0,0,1,.093-.314,2.806,2.806,0,0,1,1.423-1.589l.152-.072a4.3,4.3,0,0,1,.915-.28c3.329-.642,17.064.646,17.064.646s.385.693.915,1.551a11.853,11.853,0,0,0,2.236,2.847,4.357,4.357,0,0,1,1.444,2.5C485.716,839.581,485.6,840.27,485.047,840.478Z",
    transform: "translate(-417.698 -595.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M485.054,842.089a41.882,41.882,0,0,1-9.711,1.05c-1.855-.225-4.311-1.173-5.014-2.4s-4.612-3.093-5.663-2.974-3.388-.994-3.388-.994a3.531,3.531,0,0,1,.695-2.859l2.118,1.508s5.667,1.763,6.717,3.4,2.965,2.549,5.73,2.715c2.067.136,6.815-.671,9.038-1.075C485.724,841.193,485.609,841.881,485.054,842.089Z",
    transform: "translate(-417.705 -597.451)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M440.194,842.853a56.215,56.215,0,0,0-7.479.353c-3.977.467-7.014-1.275-7.543-1.993a17.676,17.676,0,0,0-5.374-3.994c-1.029-.4-1.271-1.7-1.224-2.915v-.2a11.94,11.94,0,0,1,.339-2.282l16.479-.353,1.427,1.942.22.3.868,1.185s.394.518.911,1.275a18.154,18.154,0,0,1,2.418,4.4h0C441.756,842.564,440.194,842.853,440.194,842.853Z",
    transform: "translate(-393.119 -596.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M440.194,846.7a56.2,56.2,0,0,0-7.479.353c-3.973.467-7.013-1.275-7.539-1.993a17.181,17.181,0,0,0-5.379-3.986c-1.029-.4-1.271-1.7-1.224-2.915,1.177.276,3.651.982,4.621,2.209,1.271,1.64,3.545,4.4,6.776,4.572,2.609.14,8.962-.327,11.291-.514C441.761,846.412,440.194,846.7,440.194,846.7Z",
    transform: "translate(-393.119 -599.896)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M438.211,831.82c-.191,1.419-.779,1.8-1.2,1.887a.813.813,0,0,1-.313,0,1.064,1.064,0,0,1-.165-.026s-14.8,3.28-17.788.624a2.056,2.056,0,0,1-.212-.221,11.934,11.934,0,0,1,.339-2.282l16.479-.353,1.427,1.942A2.8,2.8,0,0,1,438.2,831.8Z",
    transform: "translate(-393.097 -596.037)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M484.266,833.415c-.33.365-.606.574-.779.5-.779-.315-7.166-1.406-9.195-.468s-8.894.153-8.894.153,0-.816-.038-2.124a4.291,4.291,0,0,1,.915-.28c3.329-.642,17.064.646,17.064.646S483.741,832.557,484.266,833.415Z",
    transform: "translate(-420.094 -595.788)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M464.169,580.819,462.3,593.795l-2.177,8.6L457,618.651v17.208s2.025,34.238,1.245,35.172-3.74,6.259-4.519,5.948-7.166-1.406-9.195-.472-8.894.157-8.894.157-.157-13.286-.936-17.038,1.4-19.7,1.4-19.7l.779-8.6s1.093-5.787.157-7.351,1.4-7.648,1.4-7.648-1.088-3.446-.775-5.477.775-9.692.775-9.692-.775,5.32-2.939,8.443-1.889,31.11-1.889,31.11l.152,24.219c3.9,12.823,0,11.57,0,11.57s-14.8,3.284-17.788.625-2.135-19.4-2.135-19.4-.309-13.443.936-17.505,1.639-19.073,1.639-19.073-.08-30.019,0-32.045c.059-1.7,0-16.915,0-21.669v-1.406l1.787-4.453,21.176-2.66h10.131s15.247,3.595,16.822,5.145a.354.354,0,0,1,.085.094C467.443,565.659,464.169,580.819,464.169,580.819Z",
    transform: "translate(-390.332 -439.302)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M472.11,770.88s4.659,11.255,6.857,12.037S472.11,770.88,472.11,770.88Z",
    transform: "translate(-423.985 -561.203)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M476.18,809.88s15.73.782,15.573,2.5S476.18,809.88,476.18,809.88Z",
    transform: "translate(-426.331 -583.632)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M426.49,799.29c.623.59,12,1.7,11.063,2.779s-10.127,3.178-10.127,3.178Z",
    transform: "translate(-397.686 -577.541)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M422.08,753.59c0,.467,2.338,15.007,2.965,15.632s5.764,1.249,5.764,1.249Z",
    transform: "translate(-395.144 -551.259)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M439.924,281.369c-2.232,2.5-3.2,6.05-5.8,8.166-1.58,1.275-3.579,1.882-5.417,2.749s-3.659,2.188-4.206,4.151c-.61,2.209.568,4.466,1.186,6.675a27.725,27.725,0,0,1,.716,7.066c.042,2.894.089,5.787.038,8.68-.076,4.508-.449,9.224-2.833,13.044,8.61,2.749,17.767,3.123,26.8,3.476a26.955,26.955,0,0,0,5.205-.132,44.54,44.54,0,0,0,4.434-1.126,33.9,33.9,0,0,1,8.835-1.134,14.787,14.787,0,0,0,3.879-.259,3.832,3.832,0,0,0,2.8-2.469,4.6,4.6,0,0,0-.716-3.348c-1.05-1.853-2.541-3.4-3.668-5.226a14.4,14.4,0,0,1-.919-12.912c1-2.333,2.609-4.364,3.591-6.7a14.166,14.166,0,0,0-2.838-14.99c-3.418-3.51-8.322-4.869-13.015-5.592a11.8,11.8,0,0,1-5.48-2.124,9.355,9.355,0,0,0-6.243-1.215,10.179,10.179,0,0,0-6.349,3.221Z",
    transform: "translate(-396.026 -277.363)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(27.753 17.968)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M532.544,329.7a14.177,14.177,0,0,0-1.08,6.488,13.931,13.931,0,0,1,1.08-4.606c1-2.333,2.6-4.364,3.587-6.7a13.6,13.6,0,0,0,.987-6.169,13.251,13.251,0,0,1-.987,4.291C535.149,325.338,533.539,327.365,532.544,329.7Z",
    transform: "translate(-485.935 -318.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M427.7,334.237c.026,1.666.051,3.335.055,5q0-3.442-.055-6.875a27.655,27.655,0,0,0-.716-7.07,35.114,35.114,0,0,1-1.271-4.393c-.377,2.082.695,4.194,1.271,6.271A27.526,27.526,0,0,1,427.7,334.237Z",
    transform: "translate(-424.946 -319.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M473.135,397.791a14.275,14.275,0,0,1-3.875.259,33.872,33.872,0,0,0-8.83,1.113,44.847,44.847,0,0,1-4.434,1.122,26.676,26.676,0,0,1-5.209.136c-8.725-.344-17.572-.714-25.928-3.216a14.436,14.436,0,0,1-.847,1.615c8.61,2.745,17.767,3.123,26.792,3.476a26.676,26.676,0,0,0,5.209-.136,43.689,43.689,0,0,0,4.417-1.117,33.872,33.872,0,0,1,8.814-1.126,14.576,14.576,0,0,0,3.875-.263,3.835,3.835,0,0,0,2.8-2.464,3.384,3.384,0,0,0-.042-1.768A3.958,3.958,0,0,1,473.135,397.791Z",
    transform: "translate(-424.01 -362.827)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M470.924,355.311c-.313.705-1.635,6.8-1.948,7.423s-2.024,10.622-2.181,11.183-11.278-2.345-11.278-2.345l-6.7-5.63-6.882-6.87s-.2-6.2,4.866-8.188a7.705,7.705,0,0,1,1.059-.331c6.15-1.483,5.531-20.242,5.531-20.242l12.621,5.468s-2.338,10.945-2.257,13.057c.021.71.576,1.151,1.3,1.419a10.249,10.249,0,0,0,3.448.374S471.238,354.609,470.924,355.311Z",
    transform: "translate(-406.591 -307.413)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M541.034,436.265l1.792.472s1.326,2.022-1.792,3.9a54.02,54.02,0,0,0-5.688,3.99l-9.212,2.813-1.775-5.587,8.572-6.526Z",
    transform: "translate(-454.106 -367.929)",
    fill: "#502d90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M400.123,448.855l-3.583,3.518s6.463,7.5,11.435,7.971,8.178-5.706,8.178-5.706l-4.3-6.8Z",
    transform: "translate(-380.421 -375.133)",
    fill: "#502d90"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_470",
    "data-name": "Ellipse 470",
    cx: 12.464,
    cy: 12.505,
    rx: 12.464,
    ry: 12.505,
    transform: "translate(41.273 10.146)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_471",
    "data-name": "Ellipse 471",
    cx: 12.464,
    cy: 12.505,
    rx: 12.464,
    ry: 12.505,
    transform: "translate(41.273 9.206)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M470.084,565.6a40.126,40.126,0,0,0-8.339,1.874c-4.659,1.555-41.167.025-41.675,0v-1.406l1.787-4.453,21.176-2.66h10.131s15.247,3.595,16.822,5.145C470.05,565.03,470.084,565.6,470.084,565.6Z",
    transform: "translate(-393.985 -439.112)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M470.924,382.306c-.313.705-1.635,6.8-1.948,7.423s-2.024,10.622-2.181,11.183-11.278-2.345-11.278-2.345l-6.7-5.63-6.882-6.87s-.2-6.2,4.866-8.188L459.392,392.4l5.667-15.147a10.249,10.249,0,0,0,3.448.374S471.238,381.605,470.924,382.306Z",
    transform: "translate(-406.591 -334.487)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M442.531,391.985l-12.884-14.871a5.385,5.385,0,0,0-5.112-.378c-2.884,1.253-6.467,2.269-7.4,2.893a57.86,57.86,0,0,0-4.443,4.491l10.444,27.41-4.6,18.054s.7,9.224-1.088,12.585a13.851,13.851,0,0,0-1.482,6.955s.546,4.457-.076,6.8a11.359,11.359,0,0,0-.08,4.767s37.012,1.564,41.683,0a39.774,39.774,0,0,1,8.339-1.874s-.847-15.636-1.694-19.388.7-18.054.7-18.054l-1.012-15.322,6.073-15.721s-3.291-10.078-6.721-11.094a66.414,66.414,0,0,1-7.556-2.188,26.427,26.427,0,0,0-5.222-1.33l-2.046.688Z",
    transform: "translate(-389.731 -333.635)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 29.674,
    height: 45.546,
    rx: 2.94,
    transform: "matrix(0.998, 0.068, -0.068, 0.998, 42.424, 69.93)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 29.674,
    height: 45.546,
    rx: 2.94,
    transform: "matrix(0.998, 0.068, -0.068, 0.998, 43.358, 69)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 25.852,
    height: 39.189,
    transform: "matrix(0.998, 0.068, -0.068, 0.998, 45.032, 72.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 21.115,
    height: 5.908,
    transform: "translate(47.441 82.798) rotate(4.004)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 3.351,
    height: 3.077,
    transform: "matrix(0.998, 0.068, -0.068, 0.998, 64.4, 107.414)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 17.15,
    height: 3.08,
    transform: "matrix(0.998, 0.068, -0.068, 0.998, 47.336, 99.081)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 17.857,
    height: 4.733,
    transform: "matrix(0.998, 0.068, -0.068, 0.998, 49.81, 71.642)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 17.857,
    height: 4.733,
    transform: "matrix(0.998, 0.068, -0.068, 0.998, 49.81, 71.642)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M478.344,572.56s-.157,23.14-6.234,36.426c0,0,7.327-17.51,7.327-18.211s4.049-8.052,2.965-10.24S478.344,572.56,478.344,572.56Z",
    transform: "translate(-423.985 -446.976)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M467.207,302.359a8.72,8.72,0,0,1,1.41-5.825,7.174,7.174,0,0,0,5.531,7.563.941.941,0,0,1-.267-1.028,31.436,31.436,0,0,0,2.516,3.021,3.336,3.336,0,0,0,3.613.769c1.571-.85,1.588-3.089,1.182-4.831a22.714,22.714,0,0,0-5.205-9.972,6.879,6.879,0,0,0-5.463-2.787,13.4,13.4,0,0,0-7.06,1.109,18.756,18.756,0,0,0-3.388,2.375l-5.929,4.852a5.638,5.638,0,0,0-1.44,1.521,4.174,4.174,0,0,0-.449,1.593,8.6,8.6,0,0,0,3.99,8.1,6.336,6.336,0,0,1,3.782-5.948,1.651,1.651,0,0,1,.589,1.228l1.249-2.235a2.459,2.459,0,0,1,.847-1.007,2.207,2.207,0,0,1,2.389.676,4.263,4.263,0,0,0,2.177,1.44l.034-3.327",
    transform: "translate(-412.518 -283.775)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M467.231,301.258a8.723,8.723,0,0,1,1.41-5.829,7.178,7.178,0,0,0,5.536,7.563.932.932,0,0,1-.267-1.024,31.958,31.958,0,0,0,2.516,3.021,3.319,3.319,0,0,0,3.613.765c1.571-.85,1.588-3.089,1.182-4.827a22.713,22.713,0,0,0-5.205-9.972,8.333,8.333,0,0,0-2.91-2.269,8.447,8.447,0,0,0-2.541-.518,13.4,13.4,0,0,0-7.06,1.1,19,19,0,0,0-3.388,2.379l-5.929,4.852a5.579,5.579,0,0,0-1.44,1.521,4.151,4.151,0,0,0-.449,1.593,8.592,8.592,0,0,0,3.99,8.1,6.345,6.345,0,0,1,3.782-5.949,1.664,1.664,0,0,1,.589,1.228l1.245-2.226a2.432,2.432,0,0,1,.847-1.007,2.207,2.207,0,0,1,2.389.676,4.289,4.289,0,0,0,2.177,1.44l.034-3.331",
    transform: "translate(-412.541 -283.142)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M450.336,471.978c-1.088-.552-19.088,2.265-19.088,2.265a102.712,102.712,0,0,0-10.131-2.031c-7.166-1.181-7.623-8.209-7.623-8.209l-.783-14.068,2.418-2.124,10.359,6.8a33.663,33.663,0,0,1,0,4.058,5.738,5.738,0,0,0-.347,1.275.424.424,0,0,0,.347.382c.7.178,10.283,1.734,10.283,1.734s22.205-1.525,27.741,5.978a5.647,5.647,0,0,1,.978,1.853C465.862,475.016,451.323,472.466,450.336,471.978Z",
    transform: "translate(-389.742 -375.123)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M480.974,486.377c-.847.378-1.372.65-1.372.65s-7.945-.234-12.409-1.857a29.059,29.059,0,0,0-9.889-1.334s-18.6-3.212-15.717-7.406a.425.425,0,0,0,.347.383c.7.178,10.283,1.733,10.283,1.733s22.205-1.525,27.741,5.978A5.651,5.651,0,0,1,480.974,486.377Z",
    transform: "translate(-406.214 -391.595)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M488.718,441.58s1.093,7.737,1.169,8.366.47,8.2,0,9.067-1.169,2.265-1.169,2.265.779,1.64-2.338,2.269a31.93,31.93,0,0,0-6.776,2.5s-7.95-.234-12.388-1.874a28.5,28.5,0,0,0-9.894-1.33s-23.611-4.066-13.481-9.029a15.553,15.553,0,0,1,17.3,1.759l11.3-.7s4.21-2.583,5.379-2.345a4.312,4.312,0,0,0,2.414-.391l.08-8.209Z",
    transform: "translate(-406.232 -371.534)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M405.594,396.719l-2.262-.119-6.853,26.768s7.4-1.878,10.588,0,9.038,2.265,9.038,2.265l-2.181-21.338Z",
    transform: "translate(-380.386 -345.633)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M405.594,395.609l-2.262-.119-6.853,26.768s7.4-1.878,10.588,0,9.038,2.265,9.038,2.265l-2.181-21.338Z",
    transform: "translate(-380.386 -344.994)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M533.569,409.57l3.113.705s7.95,11.472,8.572,12.114-2.965,2.974-4.443,2.974-8.725.85-10.829,2.813-1.228-7.916-1.228-8.141,2.613-6.458,2.613-6.458Z",
    transform: "translate(-456.534 -353.098)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M533.569,408.47l3.113.7s7.95,11.493,8.572,12.118-2.965,2.974-4.443,2.974-8.725.85-10.829,2.813-1.228-7.916-1.228-8.141,2.63-6.48,2.63-6.48Z",
    transform: "translate(-456.534 -352.464)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(39.716 11.348)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M468.619,304.107a6.28,6.28,0,0,1,.021-.977,8.711,8.711,0,0,0-1.3,3.208v1.185c0,.688,0,1.381-.021,2.069h-.059v.319a1.709,1.709,0,0,0-.021-.327,4.5,4.5,0,0,1-2.084-1.419c-.631-.569-1.618-1.113-2.389-.676a2.432,2.432,0,0,0-.847,1.007l-1.258,2.226a1.646,1.646,0,0,0-.589-1.224,6.336,6.336,0,0,0-3.782,5.948,8.638,8.638,0,0,1-4.019-6.768,8.6,8.6,0,0,0,4.019,7.7,6.345,6.345,0,0,1,3.782-5.948,1.663,1.663,0,0,1,.589,1.228l1.245-2.226a2.432,2.432,0,0,1,.847-1.007,2.207,2.207,0,0,1,2.389.676,4.289,4.289,0,0,0,2.177,1.44q0-1.631.034-3.255A8.671,8.671,0,0,1,468.619,304.107Z",
    transform: "translate(-452.256 -303.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M487.5,312.762c.021-.289.055-.578.1-.85l.047-1.173A8.622,8.622,0,0,0,487.5,312.762Z",
    transform: "translate(-472.566 -307.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M509.433,322.306a3.327,3.327,0,0,1-3.613-.765,31.452,31.452,0,0,1-2.516-3.021.941.941,0,0,0,.267,1.028,1,1,0,0,1-.246-.064,28.056,28.056,0,0,0,2.495,2.974,3.355,3.355,0,0,0,3.613.765c1.156-.62,1.487-2.073,1.385-3.488A2.952,2.952,0,0,1,509.433,322.306Z",
    transform: "translate(-481.652 -311.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M496.165,312.224a7.217,7.217,0,0,1-5.277-6.314,7.173,7.173,0,0,0,5.548,7.321A.937.937,0,0,1,496.165,312.224Z",
    transform: "translate(-474.517 -304.729)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResource);
export default __webpack_public_path__ + "static/media/Resource.c9f01a7fdc892e3eee6c01ca1829b5f9.svg";
export { ForwardRef as ReactComponent };